import React, { Component } from 'react';
import { Bar } from 'react-chartjs-2';

class FollowersChart extends Component {

  render() {

    let {
      new_followers,
      dates
    }
      = this.props;


    let sum_new_followers = new_followers.reduce((t, i) => t += i, 0);
    let count_new_followers = new_followers.size;

    let ary_new_followers = new_followers.toArray();
    let ary_dates = dates.toArray();

    return (
      <Bar
        // height={200}
        data={{
          datasets: [
            {
              label: 'likes',
              data: ary_new_followers,
              backgroundColor: 'black',
              hoverBackgroundColor: 'deepskyblue'
            }
          ],
          labels: ary_dates
        }}
        options={{
          animation:{
            duration: 0
          },
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          title: {
            display: true,
            fontColor: 'deepskyblue',
            fontSize: 16,
            text: `${sum_new_followers.toLocaleString()} followers ` +
            `/ ${count_new_followers} hours`
          },
          tooltips: {
            enabled: true,
            callbacks: {
              label: ((tooltipItem, data) => {
                return tooltipItem.yLabel.toLocaleString();
              })
            }
          },
          scales: {
            xAxes: {
              0: {
                maxBarThickness: 20,
                gridLines: {
                  display: false,
                  drawBorder: false
                },
                ticks: {
                  autoSkip: true,
                  display: false,
                  fontSize: 11,
                  fontColor: 'blueviolet',
                  callback: ((value, index, values) => {
                    if ((index === 0) || (index === (count_new_followers - 1))) {
                      return value;
                    }
                  })
                }
              }
            },

            yAxes: {
              0: {
                display: false,
              }
            }
          }
        }}
      />
    );
  }
}


export default FollowersChart;


// WEBPACK FOOTER //
// ./src/containers/engage/charts/FollowersChart.js